import { api } from '@packages/backend/convex/_generated/api';
import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from 'convex-helpers/react';
import { MobilePageWrapper } from '@/components/ui+/MobilePageWrapper';
import { CompanyBanner } from './components/CompanyBanner';
import { SiteOccupiedForm } from './components/SiteOccupiedForm';
import { WelcomeContent } from './components/WelcomeContent';

export const Route = createFileRoute('/$companyLocationCode/$siteCode/')({
  component: Component,
});

function Component() {
  const { companyLocationCode, siteCode } = Route.useParams();
  const { data: siteWrap } = useQuery(api.app.getDataByUrlX, {
    companyLocationCode,
    siteCode,
  });

  if (!siteWrap) return null;

  return (
    <MobilePageWrapper>
      <div className="flex flex-1 flex-col space-y-6">
        <div className="flex justify-center">
          <img src="/ortomate-pay-logo.svg" alt="Orto-Mate Pay" className="h-7" />
        </div>
        <CompanyBanner
          companyName={siteWrap.companyName}
          locationAddress={siteWrap.locationAddress}
        />
        {siteWrap.site.activeSessionUuid ? (
          <SiteOccupiedForm
            companyLocationCode={companyLocationCode}
            siteCode={siteCode}
            maskedMobileNumber={siteWrap.maskedMobileNumber}
          />
        ) : (
          <WelcomeContent siteWrap={siteWrap} siteCode={siteCode} />
        )}
      </div>
    </MobilePageWrapper>
  );
}
